<ng-container [formGroup]="form">
    <div class="modern-form">
        <div class="fieldset">

            <legend>Details</legend>
            <div class="field">
                <label class="required">Description</label>
                <div class="value">
                    <textarea rows="1" rows="1" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" formControlName="description" placeholder="<Description>"></textarea>
                </div>
            </div>

            <div class="field right-align">
                <label class="required">Defect Severity</label>
                <div class="value">
                    <p-selectButton [styleClass]="$safeNavigationMigration(form?.get('severity')?.value)" formControlName="severity" [options]="severityOptions" class="flex-mode" [allowEmpty]="false"></p-selectButton>
                </div>
            </div>


            <div class="field">
                <div class="value entity">
                    <div class="box-border-left">
                        <div>{{ defect | defectEntityName}}</div>
                        <ng-container *ngIf="defect?.code?._id">
                            <div class="flex-row v-algin-middle"><i class="icomoon icomoon-docs"></i> {{form?.get('code')?.value?.name}}</div>
                            <div class="flex-row v-algin-middle"><i class="fa fa-map-marker"></i>{{$safeNavigationMigration(form?.get('code')?.value?.location) | displayText}}</div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="field">
                <label class="required">Raised By</label>
                <div class="value">
                    <employee-picker formControlName="raisedBy" placeholder="<Raised By>"></employee-picker>
                </div>
            </div>

            <div class="field">
                <label class="required">Raised Date</label>
                <div class="value">
                    <luxon-calendar formControlName="raisedAt" [dateFormat]="dateFormat" [zone]="timezone" placeholder="<Raised Date>" appendTo="body"></luxon-calendar>
                </div>
            </div>

            <div class="field">
                <label class="required">Caused By</label>
                <div class="value">
                    <defect-resources-picker [contractor]="contractor" formControlName="causedBy" placeholder="<Caused By>"></defect-resources-picker>
                </div>
            </div>
            <div class="field">
                <legend>Evidence</legend>
                <div class="value">
                    <attachment-field (deleteAttachment)="onDeleteAttachment($event)" mode="Multi" type="Images" formControlName="defectEvidence"></attachment-field>
                </div>
            </div>

            <div class="field right-align">
                <label class="required">Resolve</label>
                <div class="value">
                    <p-selectButton formControlName="resolve" [options]="resolveOptions" class="flex-mode" [allowEmpty]="false"></p-selectButton>
                </div>
            </div>

            <ng-container *ngIf="form?.get('resolve')?.value">
                <legend> Rectification</legend>

                <div class="field">
                    <label class="required">Rectified By</label>
                    <div class="value">
                        <employee-picker formControlName="rectifiedBy" placeholder="<Rectified By>"></employee-picker>
                    </div>
                </div>

                <div class="field">
                    <label class="required">Date of Rectification</label>
                    <div class="value">
                        <luxon-calendar formControlName="rectifiedAt" [dateFormat]="dateFormat" [zone]="timezone" placeholder="<Date of rectification>" appendTo="body"></luxon-calendar>
                    </div>
                </div>



                <div class="field">
                    <label>Resolution</label>
                    <div class="value">
                        <textarea rows="1" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" formControlName="resolution"></textarea>
                    </div>
                </div>

                <div class="field">
                    <legend>Attachments</legend>
                    <div class="value">
                        <attachment-field (deleteAttachment)="onDeleteAttachment($event)" mode="Multi" type="Images" formControlName="rectification"></attachment-field>
                    </div>
                </div>
            </ng-container>


        </div>
    </div>
</ng-container>